enum LogLevel {
    All = 0,
    Debug = 1,
    Info = 2,
    Warn = 3,
    Error = 4,
    Critical = 5,
    Off = 6
}

enum localStorageKeys {
    Originurl = "Originurl",
    hashKey = "hashKey",
    siteLocale = "siteLocale",
    defaultLanguageSelected = "defaultLanguageSelected",
    OrgId = "OrgId",
    languageData = "languageData",
    username = "username",
    maskmobile = "maskmobile",
    userunmaskmobile = "userunmaskmobile",
    userid = "userid",
    agentid = "agentid",
    taskid = "taskid",
    userEmail = "userEmail",
    usename = "usename",
    taskStatus = "taskStatus",
    InspectionStatus = "InspectionStatus",
    urlExpiryTime = "urlExpiryTime",
    userMobile = "userMobile",
    agentname = "agentname",
    agentphone = "agentphone",
    flag = "flag",
    statusManagementFlag = "statusManagementFlag",
    themeDetail = "themeDetail",
    DeviceInfo = "DeviceInfo",
    deviceId = "deviceId",
    sessionID = "sessionID",
    authtoken = "authtoken",
    isVerifedUser = "isVerifedUser",
    userType = "userType",
    timeZone = "timeZone",
    zoneOffset = "zoneOffset",
    widthState = "widthState",
    refreshToken = "refreshToken",
    taskChannel = "taskChannel",
    assetsBucket = "assetsBucket",
    latitude = "latitude",
    longitude = "longitude",
    accuracy = "accuracy",


}

export class AppEnum {
    public EntityOfLogLevel: typeof LogLevel = LogLevel;
    public EntityOfLocalStorageKeys: typeof localStorageKeys = localStorageKeys;
}